type Role = "admin" | "user" | "system";

const ROLE_ALLOW: Record<
  Role,
  { allowPrefixes: string[]; denyPrefixes: string[]; denyPaths?: string[] }
> = {
  admin: {
    allowPrefixes: ["/"],
    denyPrefixes: [],
  },
  system: {
    allowPrefixes: ["/"],
    denyPrefixes: [],
  },
  user: {
    allowPrefixes: ["/", "/chats", "/leads", "/outbound", "/settings"],
    denyPrefixes: ["/payments", "/ai", "/ai-settings", "/ai-settings-system"],
    denyPaths: [
      "/settings/team",
      "/settings/payment",
      "/settings/api",
      "/settings/profile",
    ],
  },
};

export function canAccess(pathname: string, role: Role) {
  const rules = ROLE_ALLOW[role] || ROLE_ALLOW.user;

  // check deny paths first
  if (rules.denyPaths && rules.denyPaths.includes(pathname)) {
    return false;
  }

  if (
    rules.denyPrefixes.some(
      (p) => pathname === p || pathname.startsWith(p + "/")
    )
  ) {
    return false;
  }

  // admin ya pasó deny => ok
  if (role === "admin" || role === "system") return true;

  return rules.allowPrefixes.some((p) =>
    p === "/" ? true : pathname === p || pathname.startsWith(p + "/")
  );
}
